<template>
    <component :is="tagName" :class="classList">
        <a
            v-if="href"
            :class="`${baseClassName}__link`"
            :href="href"
            :target="isExternal ? '_blank' : undefined"
            :rel="isExternal ? 'noopener noreferrer' : undefined"
        >
            <DsIcon v-if="icon" :name="icon" :is-in-storybook="props.isStorybook" :class="`${baseClassName}__icon`" />
            <slot></slot>
            <DsIcon name="chevron-right" />
        </a>
        <template v-else>
            <DsIcon v-if="icon" :name="icon" :is-in-storybook="props.isStorybook" :class="`${baseClassName}__icon`" />
            <slot></slot>
        </template>
    </component>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import DsIcon from "../icon/ds-icon.vue";
import { SvgIcons } from "../icon/types";

const props = withDefaults(
    defineProps<{
        type?: "floor" | "section";
        /**
         * Actually rendered tag
         */
        tagName?: keyof HTMLElementTagNameMap;
        /**
         * Icon to show
         */
        icon?: SvgIcons;
        /**
         * Whole headline will be rendered as anchor if not empty
         */
        href?: string;
        /**
         * Adds target="_blank" and rel="noreferrer noopener"
         */
        isExternal?: boolean;
        /**
         * Set theme
         */
        theme?: "light" | "dark";
        /**
         * Define postion of text
         */
        textPosition?: "left" | "center" | "right";
        /**
         * Use different image path for storybook
         */
        isStorybook?: boolean;
    }>(),
    {
        type: "floor",
        tagName: "h3",
        isExternal: false,
        theme: "light",
        textPosition: "left",
        isStorybook: false,
    }
);

const baseClassName = computed(() => `headline-${props.type}`);
const classList = computed(() => {
    const list = [baseClassName.value];
    if (props.icon) list.push(`${baseClassName.value}--icon`);
    if (props.theme === "dark") list.push(`${baseClassName.value}--dark`);
    if (props.textPosition === "left") {
        list.push(`${baseClassName.value}--left`);
    } else if (props.textPosition === "center") {
        list.push(`${baseClassName.value}--center`);
    } else if (props.textPosition === "right") {
        list.push(`${baseClassName.value}--right`);
    }
    return list;
});
</script>
